<template>
  <div class="tj-container">
    <canvas class="lz-canvas"></canvas>
    <div class="wrapper" :style="scaleStyle">
      <div class="nav">
        <div class="nav-item" :class="[tabActive == 0 ? 'active' : '']" @click="handleTabsChange(0)">
          服装技能
          <span></span>
        </div>
        <div class="nav-item" :class="[tabActive == 1 ? 'active' : '']" @click="handleTabsChange(1)">
          面板评测
          <span></span>
        </div>
        <div class="nav-item" :class="[tabActive == 2 ? 'active' : '']" @click="handleTabsChange(2)">
          服装档案
          <span></span>
        </div>
      </div>
      <div class="content">
        <div class="left">
          <Character :dataSource="dataSource.base.character" />
          <div class="panel-item" v-if="tabActive == 0" style="margin-top: 56px;">
            <Skill :dataSource="currentStyle.skill" />
          </div>
          <div class="panel-item" v-if="tabActive == 1" style="margin-top: 32px;">
            <Attr :dataSource="dataSource.base.attr" />
            <ExclusiveEquipment :dataSource="dataSource.base.exclusiveEquipment" />
            <TalentSkill :dataSource="dataSource.base.talentSkill" />
            <SkinEvalution :dataSource="dataSource.style" />
          </div>
          <div class="panel-item" v-if="tabActive == 2" style="margin-top: 47px;">
            <div class="file-tab">
              <div class="file-tab-header">
                <div class="item" :class="[fileTabActive == 0 ? 'active' : '']" @click="handleFileTabsChange(0)">
                  档案信息
                </div>
                <div class="item" :class="[fileTabActive == 1 ? 'active' : '']" @click="handleFileTabsChange(1)">
                  角色语音
                </div>
              </div>
              <div class="file-tab-container">
                <div class="item" v-if="fileTabActive == 0">
                  <Introduction :dataSource="currentStyle.introduction" />
                </div>
                <div class="item" v-if="fileTabActive == 1">
                  <Voices :dataSource="currentStyle.voices" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="live2d-box">
            <template v-if="hasAudioType && isOpenAudioChat">
              <el-tooltip :value="chatTooltip" effect="dark" content="点击与角色语音互动" placement="bottom-end">
                <div class="audio-chat-entry" @click="handleAudioChat"></div>
              </el-tooltip>
            </template>
            <Live2d
              :isShowLimit="isShowLimit"
              :dataSource="currentStyle.live2d"
              :videoSrc="currentStyle.skill.video.value"
              :attrValue="dataSource.base.character.attr1.name.value"
            />
            <div v-if="isShowLimit" class="limit-box">
              <!-- 未登录 -->
              <tempalte v-if="!loginUid">
                <div class="tip">该角色需要登录后才能观看哦~</div>
                <div class="btn" @click="handleVerify">登录</div>
              </tempalte>
              <!-- 未认证 -->
              <template v-else-if="loginUser.verify_level != 2">
                <div class="tip">该角色需实名认证后才能观看哦~</div>
                <div class="btn" @click="handleVerify">实名认证</div>
              </template>
              <!-- 已认证，未成年 -->
              <template v-else-if="!loginUser.adulthood">
                <div class="tip">您的实名信息为未成年人，部分内容无法浏览</div>
              </template>
            </div>
          </div>

          <div class="skin-box">
            <Skin :current="currentStyle" :dataSource="dataSource.style" @switch="switchStyle" />
          </div>
        </div>
      </div>

      <!-- 插入其他内容 -->
      <slot></slot>
      <!-- 分享弹窗 -->
      <ShareView
        ref="shareView"
        :detail="detail"
        :user="detail.user"
        :dataSource="dataSource"
        :currentStyle="currentStyle"
        :tabActive="tabActive"
        :fileTabActive="fileTabActive"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// components
import Character from "./components/character.vue";
import Attr from "./components/attr.vue";
import TalentSkill from "./components/talentSkill.vue";
import ExclusiveEquipment from "./components/exclusiveEquipment.vue";
import Live2d from "./components/live2d.vue";
import Skill from "./components/skill.vue";
import Introduction from "./components/introduction.vue";
import Voices from "./components/voices.vue";
import Skin from "./components/skin.vue";
import SkinEvalution from "./components/skinEvalution.vue";
import ShareView from "./shareView.vue";
// entry
import { entry } from "../entry.js";
// formatData
import { formatData } from "../utils.js";

const whiteList = ["686531", "677608", "157597", "497891"];

const entryMap = JSON.parse(JSON.stringify(entry));
export default {
  name: "DetailZSTJ",
  props: {
    isShowLimit: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Object,
      default: () => {
        return {
          content_json: "",
          entry_data_bind: []
        };
      }
    }
  },
  components: {
    Character,
    Attr,
    TalentSkill,
    ExclusiveEquipment,
    Live2d,
    Skill,
    Introduction,
    Voices,
    Skin,
    SkinEvalution,
    ShareView
  },
  data() {
    return {
      scaleStyle: {},
      tabActive: 0,
      fileTabActive: 0,
      chatTooltip: true,
      dataSource: entryMap,
      currentStyle: { key: "style1", ...entryMap.style.style1 }
    };
  },
  computed: {
    ...mapGetters(["gameInfo", "loginUid"]),
    hasAudioType() {
      return this.dataSource.base.character.audioType.value === "S_h4BRNUdf1";
    },
    isOpenAudioChat() {
      return process.env.VUE_APP_MODE !== "prod" || whiteList.includes(this.$store.getters.loginUser.uid + "");
    }
  },
  watch: {
    detail: {
      handler(val) {
        const dataSource = formatData(val.content_json, val.entry_data_bind, entryMap);
        if (dataSource) {
          this.dataSource = dataSource;
          this.currentStyle = { key: "style1", ...this.dataSource.style["style1"] };
        }
      },
      // deep: true,
      immediate: true
    }
  },
  mounted() {
    this.initCanvas();
    this.resizeScale();
    window.addEventListener("resize", this.resizeScale);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeScale);
  },
  activated() {
    this.chatTooltip = true;
    this.tabActive = 0;
    this.fileTabActive = 0;
  },
  deactivated() {
    this.chatTooltip = false;
  },
  methods: {
    resizeScale() {
      document.body.style.minWidth = "1000px";
      const width = document.body.clientWidth;
      const height = document.body.clientHeight;
      const baseWidth = 1728;
      const baseHeight = height < 911 ? 911 : height;
      if (width < baseWidth) {
        const scale = width / baseWidth;
        const wrapperWidth = baseWidth * scale;
        console.log(wrapperWidth, scale, width);
        this.scaleStyle = {
          transform: `translate(${(width - baseWidth) / 2}px,${(baseHeight * scale - baseHeight) /
            2}px) scale(${scale})`
        };
      }
    },
    handleTabsChange(index) {
      this.tabActive = index;
    },
    handleFileTabsChange(index) {
      this.fileTabActive = index;
    },
    handleVerify() {
      this.$emit("handleVerify");
    },
    switchStyle(key) {
      this.currentStyle = { key, ...this.dataSource.style[key] };
      this.$nextTick(() => {
        if (this.refreshMap) this.refreshMap();
      });
    },
    initCanvas() {
      let canvas = document.querySelector(".lz-canvas");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      if (canvas.getContext) {
        let context = canvas.getContext("2d");
        let width = canvas.width;
        let height = canvas.height;

        let r = [];
        let s = 30;
        for (let a = 0; a < s; a++) {
          const xR = Math.random();

          r.push({
            // 在width的xx%-xx%之间生成x坐标
            x:
              xR <= 0.55 && xR >= 0.88
                ? xR * width
                : xR <= 0.75
                ? (xR - Math.random() * 0.55) * width
                : (xR + Math.max(Math.random() * 0.2, 0.2)) * width,
            y: Math.random() * height,
            l: Math.random() * 1,
            xs: -4 + Math.random() * 4 + 2,
            ys: Math.random() * 5 + 1,
            h: Math.random() * 40 + 20
          });
        }
        let u = [];
        for (let b = 0; b < s; b++) {
          u[b] = r[b];
        }
        const t = () => {
          for (let c = 0; c < u.length; c++) {
            let d = u[c];
            // d.x += d.xs;
            d.y += d.ys;
            if (d.x > width || d.y > height) {
              const xR = Math.random();
              // 在width的xx%-xx%之间生成x坐标
              d.x =
                xR <= 0.55 && xR >= 0.88
                  ? xR * width
                  : xR <= 0.7
                  ? (xR - Math.random() * 0.55) * width
                  : (xR + Math.max(Math.random() * 0.2, 0.2)) * width;
              d.y = -20;
            }
          }
        };
        setInterval(() => {
          context.clearRect(0, 0, width, height);
          for (let c = 0; c < u.length; c++) {
            let d = u[c];
            context.beginPath();
            context.moveTo(d.x, height - d.y);
            context.lineTo(d.x, height - (d.y + d.l * d.ys + d.h));
            var grd = context.createLinearGradient(0, height - d.y, 0, height - (d.y + d.l * d.ys + d.h));
            grd.addColorStop(0, "rgba(255,255,255,0.05)");
            grd.addColorStop(0.4, "rgba(255,255,255,0.1)");
            grd.addColorStop(d.l < 0.3 ? 1 - d.l : d.l < 0.7 ? 1 - d.l + 0.2 : d.l, "rgba(255,255,255,0.5)");
            grd.addColorStop(0.9, "rgba(255,255,255,0.1)");
            grd.addColorStop(1, "rgba(255,255,255,0.05)");
            context.strokeStyle = grd;
            context.lineWidth = Math.random() + 1.5;
            context.lineCap = "round";
            context.stroke();
          }
          t();
        }, 50);
      }
    },
    /**
     * 计算点赞、评论侧边栏的位置，应始终吸附在主题内容右上角
     */
    refreshAsideBarStyle() {
      /** @type {HTMLDivElement} */
      const el = this.$refs.wrapper;
      if (!el) return;
      const { right, top } = el.getBoundingClientRect();
      this.asideBarStyle = {
        left: `${right + 20}px`,
        top: `${top}px`
      };
    },
    handleAudioChat() {
      this.$router.push(`/${this.alias}/audio-chat/${this.$route.params.id}`);
    }
  }
};
</script>

<style lang="less" scoped>
.tj-container {
  width: 100%;
  height: 911px;
  min-height: 100vh;
  background: linear-gradient(180deg, #18181b 0%, #161616 100%);
  // background: url("~@/assets/zs_imgs/page-bg.png");
  background-size: cover;
  overflow: hidden;
  .lz-canvas {
    position: fixed;
    z-index: 2;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
  }
  .wrapper {
    position: relative;
    display: flex;
    width: 1728px;
    height: 100%;
    margin: 0 auto;
    .nav {
      position: relative;
      z-index: 11;
      padding-top: 116px;
      flex-shrink: 0;
      width: 172px;
      height: 1920px;
      margin-left: -20px;
      // background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.05) 100%);
      border-right: 1px solid rgba(255, 255, 255, 0.13);
      .nav-item {
        position: relative;
        display: flex;
        align-items: center;
        // justify-content: flex-end;
        width: 100%;
        height: 49px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #3e4551;
        cursor: pointer;
        padding: 0 20px 0 35px;
        margin: 0 auto 28px;
        &::before {
          content: "";
          display: block;
          width: 28px;
          height: 28px;
          margin-right: 17px;
        }

        &:nth-child(1) {
          &::before {
            background: url("~@/assets/zs_imgs/nav-icon-1.png") no-repeat;
            background-size: 100% 100%;
            background-position: center;
          }
        }
        &:nth-child(2) {
          &::before {
            background: url("~@/assets/zs_imgs/nav-icon-2.png") no-repeat;
            background-size: 100% 100%;
            background-position: center;
          }
        }
        &:nth-child(3) {
          &::before {
            background: url("~@/assets/zs_imgs/nav-icon-3.png") no-repeat;
            background-size: 100% 100%;
            background-position: center;
          }
        }

        &.active {
          color: #fffeed;

          &:nth-child(1) {
            &::before {
              background: url("~@/assets/zs_imgs/nav-icon-1-active.png") no-repeat;
              background-size: 52px 52px;
              background-position: center;
            }
          }
          &:nth-child(2) {
            &::before {
              background: url("~@/assets/zs_imgs/nav-icon-2-active.png") no-repeat;
              background-size: 52px 52px;
              background-position: center;
            }
          }
          &:nth-child(3) {
            &::before {
              background: url("~@/assets/zs_imgs/nav-icon-3-active.png") no-repeat;
              background-size: 52px 52px;
              background-position: center;
            }
          }

          span {
            position: absolute;
            top: 21px;
            right: 9px;
            display: inline-flex;
            align-items: center;
            height: 10px;
            &::after {
              content: "";
              display: inline-block;
              width: 0;
              height: 0;
              border-bottom: 6px solid transparent;
              border-top: 6px solid transparent;
              border-right: 8px solid #fffeed;
            }
            // padding-right: 1px;
            // border-right: 1px solid #fffeed;
          }

          &::after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            display: block;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
            opacity: 0.1;
          }
        }
      }
    }
    .content {
      flex-shrink: 0;
      display: flex;
      .left {
        position: relative;
        z-index: 2;
        box-sizing: content-box;
        padding: 0 64px;
        width: 678px;
        .file-tab {
          .file-tab-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 666px;
            height: 46px;
            background: rgba(144, 217, 235, 0.04);
            border-radius: 4px;
            padding: 5px 5px 4px;
            .item {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 327px;
              height: 37px;
              border-radius: 4px;
              font-weight: 400;
              font-size: 16px;
              color: #959595;
              line-height: 22px;
              cursor: pointer;
              &.active {
                font-weight: bold;
                color: #392e25;
                background: #e1dad5;
              }
            }
          }
          .file-tab-container {
            width: 100%;
          }
        }
      }
      .right {
        position: relative;
        width: 2560px;
        height: 100%;
        max-height: 1080px;
        min-height: 896px;
        // background: #5989dc;
        margin-left: -980px;
        .live2d-box {
          width: 100%;
          height: 1600px;
        }
        .skin-box {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .limit-box {
    z-index: 1001;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 336px;
    height: 28px;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;

    &::before {
      content: "";
      display: block;
      position: absolute;
      z-index: 1000;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background: rgba(64, 118, 174, 0.6);
      border-radius: 0px 0px 0px 0px;
      filter: blur(16px);
    }

    .tip {
      position: relative;
      z-index: 1001;
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      line-height: 16px;
    }
    .btn {
      position: absolute;
      top: 38px;
      left: 50%;
      transform: translateX(-50%);
      font-weight: 500;
      font-size: 17px;
      color: #3eaffe;
      line-height: 16px;
      text-decoration: underline;
      text-underline-offset: 2px;
      cursor: pointer;
    }
  }
}
</style>
